import { render, staticRenderFns } from "./AFAS_3_Monthly2020.vue?vue&type=template&id=f806f9e6&"
import script from "./AFAS_3_Monthly2020.vue?vue&type=script&lang=js&"
export * from "./AFAS_3_Monthly2020.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports